import axios from '@/utils/axios';
import { Facilities } from '@/models/facilities';
import { Facility } from '@/models/facility';
import { plainToClass } from 'class-transformer';

export class FacilityService {
  static getFacilities(
    params: {
      city?: string;
      address?: string;
      store_code?: string;
      survey_id?: string;
    },
    page: number | null = 1
  ): Promise<Facilities> {
    return axios
      .get('facilities/', {
        params: { ...params, page },
      })
      .then(({ data }) => {
        return plainToClass(Facilities, data);
      });
  }

  static getFacilityById(id: string): Promise<Facility> {
    return axios.get(`facilities/${id}/`).then(({ data }) => {
      return plainToClass(Facility, data);
    });
  }
}
